
import {defineComponent} from "vue";

// eslint-disable-next-line no-unused-vars
import {File} from "@/models/Homefeed/api.model";
import HomefeedModelConfig from "@/models/Homefeed/config.model";

export default defineComponent({
  emits: [
    'set-loading',
    'invoke-success',
    'invoke-error'
  ],
  name: "TheFile",
  data() {
    return {
      homefeedModulConfig: null,
      fileContent: '',
      fileExtension: '',
      createdFile: '',
    };
  },
  created: async function () {
    this.homefeedModulConfig = await HomefeedModelConfig.getConfiguration();
  },
  methods: {
    uploadFile() {
      const newFile = {
        content: this.fileContent,
        extension: this.fileExtension
      };

      this.$http.post<File>(this.homefeedModulConfig.apiBaseUrl + `homefeed/files`, newFile)
          .then((response) => {
            if (response.status !== 200) {
              this.$emit("invoke-error", "CHYBA (STATUS: " + response.status + ") při ukládání souboru: " + response.statusText);
            }
            this.createdFile = response.data.url;
            this.fileContent = '';
            this.fileExtension = '';
            this.$emit("invoke-success", 'Hotovo!', 'Soubor byl úspěšně uložen.');
          })
          .catch((error) => {
            this.$emit("invoke-error", "CHYBA při ukládání souboru: " + error);
          });
    },
    selectFile(event: any) {
      const files = event.target.files;
      const file = files[0];

      if (files && file) {
        const reader = new FileReader();
        reader.onload =this.handleFile.bind(this);
        reader.readAsText(file, "utf-8");

        this.fileExtension = 'unknown';
        if (file.type === "application/json") {
          this.fileExtension = "json";
        }
      }
    },
    handleFile(event: any) {
      const binaryString = event.target.result;
      this.fileContent = binaryString;
    }
  }
});
